import type { AdjustmentReasonCode, Market } from '../dataProvider/types';

/** Display helpers and guardrail constants for the Manual balance adjustment surface
 *  (D-balance-adjustment, the Phase 5 capstone). */

export const ADJUSTMENT_REASON_LABEL: Record<AdjustmentReasonCode, string> = {
  goodwill: 'Goodwill',
  missed_cashback: 'Missed cashback',
  over_credit_correction: 'Over-credit correction',
  erroneous_payment_recovery: 'Erroneous payment recovery',
  other: 'Other',
};

/**
 * The per-adjustment CAP (D-balance-adjustment), per market in the market's currency.
 * It is the fat-finger guard, not a permission: an adjustment whose MAGNITUDE reaches
 * the cap goes through a deliberate large-adjustment confirmation that shows the
 * figure before it commits, so a 5000 typo for 500 is caught. A deliberate large
 * adjustment passes the same gate (there is no separate override capability; the
 * confirm IS the friction). [REVIEW] the values with the finance team as real
 * adjustment volumes land.
 */
export const ADJUSTMENT_CAP: Record<Market, number> = {
  uk: 5000,
  us: 5000,
  ie: 5000,
};

/** The direction of a manual adjustment: a credit raises the wallet, a debit lowers
 *  it. The signed ledger amount is the magnitude with this sign applied. */
export type AdjustmentDirection = 'credit' | 'debit';

export const ADJUSTMENT_DIRECTION_LABEL: Record<AdjustmentDirection, string> = {
  credit: 'Credit (add to balance)',
  debit: 'Debit (remove from balance)',
};
